import { useRef, useState, useEffect } from "react";


interface IProps {
    base64String: string,
    canvasWidth: number,
    canvasHeight: number,
    rectCoords: RectCoord,
    setRectCoords: (data: RectCoord) => void
}

export interface RectCoord {
    topLeft: { x: number, y: number }
    bottomRight: { x: number, y: number }
}

export default function ImgCanvasRange(props: IProps) {

    const { base64String, canvasWidth, canvasHeight, rectCoords, setRectCoords } = props

    const imageCanvasRef = useRef(null);
    const drawCanvasRef = useRef(null);

    const [imgWidth, setImgWidth] = useState(0);
    const [imgHeight, setImgHeight] = useState(0);

    const [isDrawing, setIsDrawing] = useState(false);
    const [startPos, setStartPos] = useState({ x: 0, y: 0 });
    const [currentPos, setCurrentPos] = useState({ x: 0, y: 0 });

    // 绘制图片到底层 canvas
    useEffect(() => {
        const imageCanvas = imageCanvasRef.current;
        const imgCtx = imageCanvas.getContext('2d');
        const img = new Image();

        img.src = 'data:image/jpeg;base64,' + base64String;

        img.onload = () => {
            imageCanvas.width = canvasWidth;
            imageCanvas.height = canvasHeight;
            setImgHeight(img.height);
            setImgWidth(img.width);
            imgCtx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
        };
    }, [base64String, canvasWidth, canvasHeight]);

    // 处理鼠标按下事件
    const handleMouseDown = (e) => {
        const drawCanvas = drawCanvasRef.current;
        const rect = drawCanvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        setIsDrawing(true);
        setStartPos({ x, y });
        setCurrentPos({ x, y });
    };

    // 处理鼠标移动事件
    const handleMouseMove = (e) => {
        if (!isDrawing) return;

        const drawCanvas = drawCanvasRef.current;
        const drawCtx = drawCanvas.getContext('2d');
        const rect = drawCanvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        setCurrentPos({ x, y });

        // 清除上层 canvas 并重新绘制矩形
        drawCtx.clearRect(0, 0, canvasWidth, canvasHeight);
        drawCtx.beginPath();
        drawCtx.rect(startPos.x, startPos.y, x - startPos.x, y - startPos.y);
        drawCtx.strokeStyle = 'red';
        drawCtx.lineWidth = 2;
        drawCtx.stroke();
    };

    // 处理鼠标松开事件
    const handleMouseUp = () => {
        if (!isDrawing) return;

        setIsDrawing(false);

        const x1 = startPos.x;
        const y1 = startPos.y;
        const x2 = currentPos.x;
        const y2 = currentPos.y;

        // 确保坐标为左上和右下
        const left = Math.min(x1, x2);
        const top = Math.min(y1, y2);
        const right = Math.max(x1, x2);
        const bottom = Math.max(y1, y2);


        //处理没有图片的情况，默认全为0
        let max_x = Math.ceil(right / canvasWidth * (imgWidth == 0 ? 2560 : imgWidth));
        if (max_x <= 1) {
            max_x = 100;
        }
        let max_y = Math.ceil(bottom / canvasHeight * (imgHeight == 0 ? 1440 : imgHeight));
        if (max_y <= 1) {
            max_y = 100;
        }

        const rectCorners = {
            topLeft: { x: Math.floor(left / canvasWidth * imgWidth), y: Math.floor(top / canvasHeight * imgHeight) },
            bottomRight: { x: max_x, y: max_y },
        };

        setRectCoords(rectCorners);
    };

    return (
        <>
            <div style={{ position: 'relative', width: canvasWidth, height: canvasHeight + 30 }}>
                {/* 底层 canvas，用于显示图片 */}
                <canvas
                    ref={imageCanvasRef}
                    width={canvasWidth}
                    height={canvasHeight}
                    style={{ position: 'absolute', top: 25, left: 0, zIndex: 0 }}
                ></canvas>

                {/* 上层 canvas，用于绘制矩形 */}
                <canvas
                    ref={drawCanvasRef}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    width={canvasWidth}
                    height={canvasHeight}
                    style={{ position: 'absolute', top: 25, left: 0, zIndex: 1, cursor: 'crosshair' }}
                ></canvas>
                {/* 显示矩形坐标 */}
                <div style={{ marginTop: '0px' }}>
                    <p>框选范围： 左上角({rectCoords.topLeft.x ? rectCoords.topLeft.x : 0}, {rectCoords.topLeft.y ? rectCoords.topLeft.y : 0}) 右下角({rectCoords.bottomRight.x ? rectCoords.bottomRight.x : imgWidth}, {rectCoords.bottomRight.y ? rectCoords.bottomRight.y : imgHeight})</p>
                </div>
            </div>
        </>

    );
}